import React from 'react'

const VedicMaths = () => {
  return (
    <div>VedicMaths</div>
  )
}

export default VedicMaths